import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Browser } from 'src/app/shared/model/browser.model';
import { LoginForm } from 'src/app/shared/model/loginForm.model';
import { AccountService } from 'src/app/shared/service/account.service';
import { SessionService } from 'src/app/shared/service/session.service';
import { SyncToStgService } from 'src/app/shared/service/sync-to-stg.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-session-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class SessionLoginComponent implements OnInit, OnDestroy {
  loginForm: LoginForm;
  uuid: string;
  email: string;
  password: string;
  showOtpForm: boolean = false;
  otpAttempt: string;
  showBrowserForm: boolean = false;
  newBrowserName: string;
  browsers: Browser[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private accountService: AccountService,
    private sessionService: SessionService,
    private toastrService: ToastrService,
    private activateRouter: ActivatedRoute,
    private syncToStgService: SyncToStgService
  ) {}

  ngOnInit() {
    if (localStorage.account) {
      // 案件一覧画面遷移
      this.router.navigate(['/matching/projects']);
    }
    this.uuid = localStorage.getItem('uuid');
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  signIn() {
    this.loginForm = {
      email: this.email,
      password: this.password,
      uuid: this.uuid
    };
    const login$ = this.sessionService.signIn(this.loginForm);

    const sub = login$.subscribe(
      res => {
        // otp_flg=trueの場合、二要素認証画面を表示
        this.showOtpForm = res.body.data.otp_flg;

        // スマホ端末を除き、登録済みブラウザにuuidがない場合、ブラウザ登録画面を表示
        // 以下の場合はブラウザ判定をスキップ
          // - emailが 'igarashi.keita.' で始まる(マスターアカウント)
          // - emailが 'cotegg@' で始まる(開発・テスト用アカウント)
          // - emailが 'guest_sier' を含む(v2SIer用のアカウント)
        this.browsers = res.body.data.browsers;
        this.showBrowserForm =
          !res.body.data.is_phone &&
          !this.browsers.some(browser => browser.uuid == this.uuid) &&
          !res.body.data.email.startsWith('igarashi.keita.') &&
          !res.body.data.email.startsWith('cotegg@') &&
          !res.body.data.email.includes('guest_sier');

        if (!this.showOtpForm && !this.showBrowserForm) {
          this.afterLogin(this.loginForm, res);
        }
      },
      error => {
        let message = error.error.errors[0] || 'ログインに失敗しました';
        this.toastrService.error(message);
      }
    );
    this.subscriptions.push(sub);
  }

  verify() {
    const param = {
      ...this.loginForm,
      otp_attempt: this.otpAttempt
    };
    this.otpAttempt = null;

    const sub = this.sessionService.verifyOtp(param).subscribe(
      res => {
        if (this.showBrowserForm) {
          this.showOtpForm = false;
        } else {
          this.afterLogin(this.loginForm, res);
        }
      },
      error => {
        let message =
          error.error.errors[0] ||
          '二要素認証に失敗しました. 再度お試しください';
        this.toastrService.error(message);

        // 認証コードの期限が切れていた場合は、引き続き認証コード入力フォームを表示
        // それ以外のエラーの場合は、ログインフォームを表示
        if (error.error.retry !== true) {
          this.showOtpForm = false;
        }
      }
    );
    this.subscriptions.push(sub);
  }

  cancel(event) {
    event.preventDefault();
    this.otpAttempt = null;
    this.showOtpForm = false;
    this.showBrowserForm = false;
  }

  afterBrowserRegister(event) {
    this.afterLogin(event.loginForm, event.response);
  }

  private afterLogin(loginForm, res) {
    const query_project_detail = this.activateRouter.snapshot.queryParams[
      'project_detail'
    ];
    const query_worker_detail = this.activateRouter.snapshot.queryParams[
      'worker_detail'
    ];

    // Headerの情報を取得、sessionにトークン設定
    this.accountService.setAccount(res);
    localStorage.setItem('uuid', res.body.data.uuid);

    if (query_project_detail) {
      // 通知からの遷移時の処理 ex) /login?project_detail=1
      this.router.navigate(['/matching/projects/' + query_project_detail]);
      this.toastrService.success('ログインに成功しました');
    } else if (query_worker_detail) {
      // 通知からの遷移時の処理 ex) /login?worker_detail=1
      this.router.navigate(['/matching/workers/' + query_worker_detail]);
      this.toastrService.success('ログインに成功しました');
    } else {
      // 案件一覧画面遷移
      this.router.navigate(['/matching/projects']);
      this.toastrService.success('ログインに成功しました');
    }

    if (res.body.data.auth === 'admin_user') {
      this.syncToStgService.signIn(loginForm);
    }
  }
}
